import type { ReactNode } from 'react';

/**
 * A section divider: a rule, a heading, and a slot on the right for whatever
 * steers that section.
 *
 * Shared with the car detail page, which had it first. The dashboard grew to ten
 * panels in one flat column with nothing to say where one subject stopped and the
 * next began, and inventing a second look for the same job would have made the
 * two pages read as two products.
 *
 * The right-hand slot matters: a control that steers a whole section belongs in
 * its header, not floating above the first panel it happens to touch.
 */
export function SectieKop({ titel, children }: { titel: string; children?: ReactNode }) {
  return (
    <div
      style={{
        marginTop: 10,
        paddingTop: 14,
        borderTop: '2px solid #111111',
        display: 'flex',
        alignItems: 'baseline',
        justifyContent: 'space-between',
        gap: 12,
        flexWrap: 'wrap',
      }}
    >
      <h2 style={{ margin: 0, fontSize: 20, fontWeight: 900, color: '#111111' }}>{titel}</h2>
      {children}
    </div>
  );
}
